export default __webpack_public_path__ + "static/media/logo192.23496c44.png";